export default __webpack_public_path__ + "static/media/logo.32eef6c2.svg";